/* Shared contract metadata — labels, accent colors, icons.
 * Used by ContractsTab in client folder + anywhere contract types are shown.
 */

export const CONTRACT_TYPE_LABEL = {
  hypoteka: "Hypotéka", stavebni: "Stavební spoření", uver: "Úvěr",
  investice: "Investice", penzijko: "Penzijní spoření (DPS)",
  pojisteni_zivot: "Životní pojištění", pojisteni_auta: "Pojištění auta",
  pojisteni_majetek: "Pojištění majetku", zdravotni: "Zdravotní", jine: "Jiné",
  /* Od 4. 10. 2026 vlastní druhy (dřív „Jiné“) — mají výpověď do pojišťovny
   * i hlídání výročí. Seznam = backend models_contracts.ContractType
   * (hlídá __tests__/druhySmluvSlozka.test.js). */
  pojisteni_odpovednost: "Pojištění odpovědnosti",
  pojisteni_ostatni: "Ostatní pojištění",
};

// Per-product accent colors matching the calendar event palette (iOS-style)
export const CONTRACT_TYPE_COLOR = {
  hypoteka: "#FF9500",       stavebni: "#5AC8FA",
  uver: "#FF453A",           investice: "#34C759",
  penzijko: "#5856D6",       pojisteni_zivot: "#AF52DE",
  pojisteni_auta: "#FFCC02", pojisteni_majetek: "#FF2D55",
  zdravotni: "#30B0C7",      jine: "#8E8E93",
  pojisteni_odpovednost: "#A2845E", pojisteni_ostatni: "#007AFF",
};

/* BARVA TEXTU v barvě typu — štítek pojišťovny, „Měsíčně“ a tlačítko
 * Výpověď na kartě smlouvy. Paleta výš je z kalendáře a jako barva PÍSMA
 * nestačí: na bílé má #A2845E 3,5 : 1, #007AFF 4,0 : 1, majetek 3,65 : 1,
 * žlutá auta 1,5 : 1 (CLAUDE.md chce u textu aspoň 4,5 : 1; nález ověření
 * 4. 10. 2026). Proto se barva typu smíchá s --ink motivu: 30 % barvy +
 * 70 % inkoustu drží odstín a ve všech šesti motivech (i Midnight) dá
 * ≥ 4,5 : 1 — hlídá __tests__/smlouvyStaryBackendAKontrast.test.js.
 * Proužek a podklad štítku zůstávají v čisté barvě (jsou to plochy, ne text). */
export const PODIL_BARVY_TYPU_V_TEXTU = 30;
export function barvaTextuTypu(type) {
  const c = CONTRACT_TYPE_COLOR[type] || CONTRACT_TYPE_COLOR.jine;
  return `color-mix(in oklab, ${c} ${PODIL_BARVY_TYPU_V_TEXTU}%, var(--ink))`;
}

/* Ikona typu smlouvy: lib/ikony/ikonyProduktu.js → ikonaProduktu(ct.type).
 * Dřív tu byla emoji (CONTRACT_TYPE_ICON) — 🏦 znamenalo stavební spoření
 * i penzi, 🪙 Windows 10 nenakreslí. Odstraněno 30. 9. 2026. */
